(() => {
const root = document.querySelector('[data-tw-loudness]');
if (!root || root.dataset.bound) return;
root.dataset.bound = 'true';
"use strict";
const dialog=document.getElementById('figure-zoom');
const zoomImage=document.getElementById('figure-zoom-image');
let opener;
document.querySelectorAll('.loudness-figure-open').forEach(button=>{
  button.addEventListener('click',()=>{
    const image=button.querySelector('img');
    opener=button;
    zoomImage.src=image.src;
    zoomImage.alt=image.alt;
    dialog.querySelector('.loudness-zoom-tools p').textContent=image.alt;
    dialog.showModal();
    dialog.querySelector('.loudness-zoom-scroll').scrollTo(0,0);
  });
});
document.getElementById('figure-zoom-close').addEventListener('click',()=>dialog.close());
dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
dialog.addEventListener('close',()=>{if(opener)opener.focus({preventScroll:true});});


const footer=root.querySelector('.tw-loudness-share');
if(!document.querySelector('script[src^="https://platform-api.sharethis.com/js/sharethis.js"]')){
  const share=document.createElement('script');share.async=true;
  share.src='https://platform-api.sharethis.com/js/sharethis.js#property=66b03d2a969157001920a62f&product=inline-share-buttons&source=shopify';
  document.head.append(share);
}
const labels={twitter:'Xで共有',facebook:'Facebookで共有',sharethis:'その他の方法で共有'};
const prepare=()=>footer.querySelectorAll('.st-btn[data-network]').forEach(button=>{
  const label=labels[button.dataset.network];
  if(!label)return;
  button.tabIndex=0;button.setAttribute('role','button');button.setAttribute('aria-label',label);
});
new MutationObserver(prepare).observe(footer,{childList:true,subtree:true});
prepare();
footer.addEventListener('keydown',event=>{
  const button=event.target.closest('.st-btn[data-network]');
  if(button&&footer.contains(button)&&(event.key==='Enter'||event.key===' ')){
    event.preventDefault();button.click();
  }
});
// Keep the primary article URL even in Shopify's draft-preview proxy.
const shareWidget=footer.querySelector('.sharethis-inline-share-buttons');
const canonicalShareURL=['https:','','shop.'+'topwing.jp'].join('/')+'/blogs/news/where-did-the-loudness-war-go';
shareWidget.dataset.url=canonicalShareURL;
const initializeCanonicalShare=()=>{
  if(!window.__sharethis__?.load)return false;
  shareWidget.id='tw-loudness-share-buttons';
  shareWidget.dataset.url=canonicalShareURL;
  window.__sharethis__.load('inline-share-buttons',{
    id:shareWidget.id,alignment:'center',enabled:true,font_size:12,padding:10,
    radius:4,networks:['twitter','facebook','sharethis'],size:40,spacing:8,
    labels:'cta',language:'ja',show_total:false,min_count:0,
    url:canonicalShareURL,title:shareWidget.dataset.title
  });
  return true;
};
if(!initializeCanonicalShare()){
  let attempts=0;
  const timer=setInterval(()=>{if(initializeCanonicalShare()||++attempts>=100)clearInterval(timer)},200);
}

let shareMenuOpener;
const restoreShareFocus=opener=>{
  opener.focus({preventScroll:true});
  setTimeout(()=>{
    if(opener.isConnected&&(document.activeElement===document.body||document.activeElement===opener))opener.focus({preventScroll:true});
  },350);
};
footer.addEventListener('click',event=>{
  const button=event.target.closest('.st-btn[data-network="sharethis"]');
  if(!button)return;
  shareMenuOpener=button;
  requestAnimationFrame(()=>{
    const close=document.querySelector('.st-close');
    if(close){close.tabIndex=0;close.setAttribute('role','button');close.setAttribute('aria-label','共有メニューを閉じる')}
  });
});
document.addEventListener('keydown',event=>{
  if(!shareMenuOpener)return;
  const close=document.querySelector('.st-close');
  if(!close||!close.getBoundingClientRect().width)return;
  if(event.key==='Escape'||(event.target===close&&(event.key==='Enter'||event.key===' '))){
    event.preventDefault();const opener=shareMenuOpener;close.click();restoreShareFocus(opener);shareMenuOpener=null;
  }
});
document.addEventListener('click',event=>{
  if(shareMenuOpener&&event.target.closest('.st-close')){
    restoreShareFocus(shareMenuOpener);shareMenuOpener=null;
  }
});

})();
